module.exports = __webpack_public_path__ + "static/imbiased-api-c6332a544492445cd24df1f26a398c29.jpg";